import TemplateEmpty from '../app/templates/TemplateEmpty'
import Login from '../app/pages/Login'
import FirstAccess from '../app/pages/FirstAccess'
import ForgotPassword from '../app/pages/ForgotPassword'
import CreateNewPassword from '../app/pages/CreateNewPassword'
import Mfa from '../app/pages/Mfa'
import Terms from '../app/pages/Terms'

export default {
  path: '/conta',
  component: TemplateEmpty,
  routes: [
    {
      path: '/conta/login',
      exact: true,
      component: Login
    },
    {
      path: '/conta/esqueci-a-senha',
      exact: true,
      component: ForgotPassword
    },
    {
      path: '/conta/primeiro-acesso',
      exact: true,
      component: FirstAccess
    },
    {
      path: '/conta/criar-senha',
      exact: true,
      component: CreateNewPassword
    },
    {
      path: '/conta/mfa',
      exact: true,
      component: Mfa
    },
    {
      path: '/conta/termos',
      exact: true,
      component: Terms
    }
  ]
}
